"use client";
import React, { useEffect, useRef } from "react";
import "./bottombar.css";
import {
  IconSmartHome,
  IconSearch,
  IconTicket,
  IconUser,
} from "@/lib/icons";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { useLayout } from "@/lib/LayoutContext";

export default function BottomNav() {
  const path = usePathname();
  const { setOffset, removeOffset } = useLayout();
  const navRef = useRef(null);

  useEffect(() => {
    const updateOffset = () => {
      if (navRef.current && window.innerWidth < 768) {
        setOffset("mobile-bottom-nav", 60);
      } else {
        removeOffset("mobile-bottom-nav");
      }
    };

    updateOffset();
    window.addEventListener("resize", updateOffset);

    let resizeObserver;
    if (navRef.current && typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateOffset);
      resizeObserver.observe(navRef.current);
    }

    return () => {
      window.removeEventListener("resize", updateOffset);
      resizeObserver?.disconnect();
      removeOffset("mobile-bottom-nav");
    };
  }, [setOffset, removeOffset]);

  const navItems = [
    {
      label: "Home",
      icon: <IconSmartHome size={22} />,
      route: "/",
    },
    {
      label: "Search",
      icon: <IconSearch size={22} />,
      route: "/search",
    },
    {
      label: "Tickets",
      icon: <IconTicket size={22} />,
      route: "/tickets",
    },
    {
      label: "Profile",
      icon: <IconUser size={22} />,
      route: "/profile",
    },
  ];

  return (
    <nav className="bottom-bar" id="mobile-nav" ref={navRef} aria-label="Main navigation">
      {navItems.map((item) => {
        const isActive =
          item.route === "/tickets"
            ? path.startsWith("/tickets")
            : path === item.route;

        return (
          <Link
            key={item.route}
            href={item.route}
            className={`tab ${isActive ? "active" : ""}`}
            prefetch={item.route === "/" ? false : undefined}
            title={`Go to ${item.label}`}
            id={`nav-${item.label.toLowerCase()}`}
          >
            <span className="tab-icon">{item.icon}</span>
            <span className="tab-label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
